import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var BONUS_LINK_MESSAGE = {
  BONUS_LINK_MESSAGE_DESCRIPTION: "You've got",
  BONUS_LINK_MESSAGE_BUTTON: 'COLLECT',
  BONUS_LINK_MESSAGE_INVALID_TITLE: 'SORRY',
  BONUS_LINK_MESSAGE_INVALID_DESCRIPTION: 'You have already claimed this bonus or the promotion has expired.'
};
var MESSAGES = {
  MESSAGES_TITLE: 'MESSAGES',
  MESSAGES_DESCRIPTION_TITLE: "YOU'RE UP TO DATE",
  MESSAGES_DESCRIPTION: 'Come back later!',
  MESSAGES_FOOTER: 'Note: Messages older than 3 days get automatically deleted'
};
var REGISTER_REWARD_CARD = {
  REGISTER_REWARD_CARD_TITLE: 'SIGN UP FOR A REWARD CARD',
  REGISTER_REWARD_CARD_DESCRIPTION: 'Enter your information below to create your Reward Card account',
  REGISTER_REWARD_CARD_DATE: 'Date of Birth',
  REGISTER_REWARD_TERMS_AGREE_MESSAGE: 'By signing up for a reward card, you also agree to the',
  REGISTER_REWARD_CARD_BUTTON: 'REGISTER',
  REGISTER_REWARD_CARD_SUCCESS: 'Your account has been linked!',
  REGISTER_REWARD_CARD_ERROR_MESSAGE: 'The age must be over 18 years old and the form needs be complete to submit'
};
var MODAL_TITLE = {
  SHARE_EMAIL: 'Share email',
  TRY_AGAIN: 'Try Again'
};
var TERMS_MODAL = {
  DECLINE: 'DECLINE',
  NEED_HELP: 'Need Help?'
};
var CONGRATS = {
  CONGRATULATIONS: 'CONGRATULATIONS',
  YOU_HAVE_EARNED: "You've Earned"
};
var AD_BLOCK = {
  ADBLOCK_TITLE: 'Ad blocker detected!',
  ADBLOCK_DESCRIPTION: ['Ad Blockers can stop our games from loading.', 'Please disable your ad blocker and refresh the page for a better experience!']
};
var ON_DEMAND_RESOURCES = {
  ODR_DOWNLOAD_ERROR: 'An error has occurred while downloading the game.'
};
var SETTINGS = {
  CHEAT_MENU: 'CHEAT MENU',
  SIGN_OUT: 'SIGN OUT',
  CONFIRM_LOG_OUT: 'Are you sure you want to logout?',
  VERSION: 'Version ',
  EMAIL: 'Email',
  EDIT: 'Edit',
  CHANGE_PASSWORD: 'Change Password',
  USE_STRONG_PASSWORD: "Use a strong password that you don't use elsewere",
  SUCCESS_RESPONSE: 'Success!',
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  MESSAGE_SUCCESSFULLY_SENT: 'Your message has been successfully sent!',
  BACK_TO_YOU_SHORTLY: 'We will get back to you shortly!',
  WE_WILL_GET_BACK_TO_YOU: 'We will get back to you within 48 hours.',
  TRY_AGAIN_OR_CONTACT_SUPPORT: 'Try again or contact customer support.',
  PLEASE_SUBMIT_A_REQUEST: 'For us to be able to communicate with you, please submit a request through our ',
  SUPPORT_PORTAL: 'Support Portal',
  DONE: 'DONE',
  DETAILS_UPDATED: 'Your details have been updated',
  CONTACT_SUPPORT_FAILED: 'Contact support failed',
  CONTACT_SUPPORT: 'Contact Support',
  ACCOUNT: 'Account',
  SOUND_EFFECTS: 'Sound Effects',
  MUSIC: 'Music',
  DELETE_ACCOUNT: 'DELETE ACCOUNT',
  DELETE: 'DELETE',
  ENV_CHANGED: 'Environment changed. Please log in again.',
  PASSWORDS_DONT_MATCH: "Passwords don't match!",
  PASSWORD_SUCCESSFULLY_CHANGED: 'Your password has been successfully changed!',
  PLAYER_ID: 'Player ID',
  MEMBER_ID: 'Member ID',
  MY_USER_ID: 'My ID',
  USER_AGENT: 'User Agent',
  DEVICE: 'Device',
  SYSTEM_VERSION: 'System Version',
  APP_VERSION: 'App Version',
  CUSTOMER_SUPPORT_TITLE: 'CONTACT SUPPORT',
  MESSAGE_SENT_TITLE: 'MESSAGE SENT',
  MESSAGE_SENT_ERROR_TITLE: 'MESSAGE SENT ERROR',
  ACCOUNT_TITLE: 'ACCOUNT',
  CHANGE_PASSWORD_TITLE: 'CHANGE PASSWORD',
  CHANGE_PASSWORD_SUCCESS_TITLE: 'UPDATE SUCCESSFUL',
  CHANGE_PASSWORD_ERROR_TITLE: 'UPDATE ERROR',
  UPDATE_EMAIL_TITLE: 'UPDATE EMAIL',
  UPDATE_EMAIL_SUCCESS_TITLE: 'UPDATE SUCCESSFUL',
  UPDATE_EMAIL_ERROR_TITLE: 'UPDATE ERROR',
  TERMS_AND_CONDITIONS_SETTING_TITLE: 'TERMS AND CONDITIONS',
  PRIVACY_POLICY_TITLE: 'PRIVACY POLICY',
  SETTINGS_TITLE: 'SETTINGS',
  CUSTOMER_SUPPORT_FORM_TITLE: 'Message Title',
  CUSTOMER_SUPPORT_FORM_BODY: 'Type your message here',
  CUSTOMER_SUPPORT_FORM_SEND: 'SEND',
  CURRENT_PASSWORD: 'Current password',
  UPDATE_PASS_BUTTON: 'UPDATE',
  SETTINGS_COPYRIGHT: ''
};
var OFFER_DETAIL = {
  CONGRATULATIONS: 'Congratulations',
  KYC_CHECK: 'KYC CHECK!',
  OOPS: 'Oops!',
  PURCHASE_AND_USAGE_LIMITATIONS: 'Purchase & Usage Limitations:',
  REWARD_CENTER_KYC_MESSAGE: 'To redeem this reward we need to verify your identity!'
};
var EVENTS = {
  EVENTS_ERROR_TOOLTIP: 'Under Maintenance',
  EVENTS_COMING_TOOLTIP: 'Coming Soon',
  EVENTS_MUST_UPDATE_TOOLTIP: 'Please update the app',
  EVENTS_ENTRIES_TITLE: 'Entries:',
  EVENTS_COMPLETED_LABEL: 'COMPLETED',
  EVENTS_HERE_LABEL: 'HERE'
};
var DAILY_SPIN = {
  DAILY_BONUS_DAY_10: '10',
  DAILY_BONUS: 'DAILY BONUS',
  DONT_BREAK_YOUR_STREAK: "Don't break your streak!",
  PLUS_SYMBOL: '+',
  SPIN: 'SPIN',
  TIER_BONUS: 'TIER BONUS',
  TIER_BONUS_NOT_LINKED: 'Link Card for EXTRA COINS!',
  WHEEL_BONUS: 'WHEEL BONUS',
  MAINTAIN_LOGIN: 'Come back everyday to maintain your login streak!',
  UNLOCK_TIER_BONUS: 'Unlock a BIGGER tier bonus, by reaching the next tier!',
  LOGIN_EVERY_DAY: 'Log in every day for better rewards!'
};
var VIDEO_ADS = {
  ARE_YOU_SURE: 'ARE YOU SURE?',
  CLOSE_VIDEO_MODAL: 'CLOSE',
  DEFAULT_ERROR_MESSAGE: 'Something went wrong, Please try again later!',
  KEEP_WATCHING: 'KEEP WATCHING',
  VIDEO_ERROR: 'ERROR',
  WILL_NOT_RECEIVE_COINS: 'You will not receive your coins if you do not watch the full video'
};
var WATCH_AND_EARN_INFO = {
  ALREADY_WATCHED_ALL: 'You have already watched all the videos for the day',
  COME_BACK_IN: 'COME BACK IN',
  COME_BACK_LATER: 'COME BACK LATER'
};
var WEB_FINISH_PURCHASE = {
  PLEASE_WAIT: 'PLEASE WAIT',
  PROCESSING_REQUEST: 'We are processing your request...'
};
var TOOLTIP = {
  BETTER_REWARDS: 'BETTER REWARDS',
  AND_BIGGER_BETS: 'AND BIGGER BETS'
};
var TERMS_AND_CONDITIONS = {
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  TERMS_AND_CONDITIONS_TITLE: 'terms and conditions',
  PRIVACY_POLICY: 'Privacy Policy',
  CONTINUE_BUTTON: 'CONTINUE',
  STAR_AGE_AGREEMENT: 'I confirm I am over the age of 18 & I agree to the StarPlay',
  STAR_CONSENT_TO_MARKETING: '. I consent to receiving marketing & promotional material from StarPlay.',
  STAR_PRIVACY_COLLECTION_TITLE: 'Privacy Collection Statement',
  STAR_PRIVACY_COLLECTION_BODY: 'The Star Entertainment Group collects, uses and discloses your personal information (including sensitive information) for the purposes of sending marketing materials (about our business partners’ or our own) promotions, products, services, events and special offers, undertaking analytics activities and for the other purposes outlined in our',
  STAR_PRIVACY_POLICY_PART_ONE: '. Without this information, we may not be able to do so. Our',
  STAR_PRIVACY_POLICY_PART_TWO: 'contains information on who we may disclose your personal information to (including Government and overseas entities), how to access or correct your personal information and privacy complaints.',
  TERMS_UPDATE_SCREEN_TEXT: 'I confirm I am over the age of 18 & I agree to the Terms &  Conditions. I consent to receiving marketing & promotional material & agree to the Privacy Policy.'
};
var AUTH_SWITCH = {
  CONFIRMATION: 'Are you sure?',
  WONT_SAVE: "Your progress won't be saved.",
  CANCEL: 'Cancel',
  LEAVE: 'Leave'
};
var AUTO_FORM_INPUT = {
  ADDRESS_MANUALLY: 'Enter Address Manually',
  SEARCH_ADDRESSES: 'Search addresses',
  SELECT_ITEM: 'Select an item...',
  NO_MATCHES: 'No matches found - enter address manually'
};
var SMART_BANNER = {
  AVAILABLE_IN: 'Available in',
  NOT_AVAILABLE: 'Not available',
  RESET_PASSWORD_TITLE: 'CHOOSE PASSWORD'
};
var FORM = {
  DECLINE_FORM: 'Decline',
  SUBMIT: 'SUBMIT',
  NEXT_STEP: 'GO_TO_NEXT_STEP'
};
var GAMETILE = {
  FROM: 'FROM',
  LEVEL: 'LEVEL',
  TAP_START: 'TAP TO START PLAYING!',
  ADD_FAVOURITE_ERROR: 'An error has occured while adding this favourite',
  REMOVE_FAVOURITE_ERROR: 'An error has occured while removing this favourite',
  PANEL_NOT_SUPPORTED_ERROR: 'This panel is not supported yet'
};
var SIDE_MENU = {
  GAME_ADDED_TO_FAVS: 'Well done! The game has been added to your favourites list! Tap on the Favourites Tab to view your favourite games',
  SIDE_BAR_FAVORITE: 'FAVORITES',
  SIDE_BAR_FAVORITE_STAR: 'FAVOURITES',
  SIDE_BAR_VIP: 'HIGH LIMIT ROOM',
  SIDE_BAR_VIP_STAR: 'VIP ROOM',
  SIDE_BAR_SLOT: 'SLOT GAMES',
  SIDE_BAR_TABLE: 'TABLE GAMES'
};
var GAME_VIEW = {
  GO_BACK: 'Go Back'
};
var IAP_TERMS = {
  AGREE_TERMS: 'I agree to the Terms and Conditions',
  TERMS_AND_CONDITIONS_IAP: 'Terms and Conditions'
};
var LEVEL_BAR = {
  NEXT_LEVEL: 'NEXT LEVEL-UP REWARD',
  MAX: 'Max'
};
var LEVEL_UP = {
  LEVEL_UP_MESSAGE: 'LEVEL-UP',
  NEW_GAME: 'NEW GAME UNLOCKED'
};
var AUDIO_VIEW = {
  AUDIO_VIEW_TITTLE: 'AudioView',
  BUTTON_PLAY: 'Play One Time Sound',
  BUTTON_START: 'Start Background Music',
  BUTTON_STOP: 'Stop Background Music',
  BUTTON_MODAL: 'Show Modal'
};
var DATE_PICKER = {
  BUTTON_CONFIRM: 'Confirm'
};
var MESSAGE_ITEM = {
  COLLECT_BUTTON: 'COLLECT',
  REDEEM_BUTTON: 'REDEEM',
  PLAY_BUTTON: 'PLAY',
  BUY_BUTTON: 'BUY',
  SNEAK_PEEK_BUTTON: 'PLAY NOW',
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
  VIP_PASS_SUBTITLE_REDEEM: 'Redeem your FREE! ',
  VIP_PASS_SUBTITLE_EXCLUSIVE: ' of exclusive ',
  VIP_PASS_SUBTITLE_ACCESS: ' access now!',
  OFFER_TYPE_SUBTITLE_GET: 'Get your ',
  OFFER_TYPE_SUBTITLE_COINS: ' coins for only ',
  FIND_OUT_MORE: 'Find out more...',
  COLLECT_REWARD_CONGRATS: 'Congratulations!',
  COLLECT_REWARD_ADDED: 'have been added to your account!'
};
var MESSAGE_DETAILS = {
  OK: 'OK',
  REWARD_INFO: 'Reward Info',
  REWARD_COLLECTED: 'Reward Collected! You got',
  COLLECT_BUTTON: 'COLLECT',
  REDEEM_BUTTON: 'REDEEM',
  PLAY_BUTTON: 'PLAY',
  BUY_BUTTON: 'BUY',
  SNEAK_PEEK_BUTTON: 'PLAY NOW',
  HOURS: 'hours',
  HOUR: 'hour',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
  VIP_PASS_SUBTITLE_REDEEM: 'Redeem your FREE! ',
  VIP_PASS_SUBTITLE_EXCLUSIVE: ' of exclusive ',
  VIP_PASS_SUBTITLE_ACCESS: ' access now!',
  OFFER_TYPE_SUBTITLE_GET: 'Get your ',
  OFFER_TYPE_SUBTITLE_COINS: ' coins for only ',
  FIND_OUT_MORE: 'Find out more...',
  REDEEM_MESSAGE_CONGRATS: 'Congratulations!',
  REDEEM_MESSAGE_CONGRATS_TEXT: 'have been added to your account!'
};
var HISTORY_DETAIL = {
  NO_EXPIRY_DATE: 'No expiry date',
  EXPIRES_ON: 'Expires on',
  EMAIL_SENT_MESSAGE: 'Barcode email has been sent, go check your email.',
  ISSUED_ON: 'Issued on: ',
  SEND_EMAIL: 'Send Email',
  REMAINING_BALANCE: 'Remaining Balance: '
};
var HISTORY_LIST = {
  NO_OFFERS_REDEEMED_YET: 'No offers redeemed yet',
  OFFER: 'Offer',
  STATUS: 'Status',
  REDEMPTION_DATE: 'Redemption Date',
  REMAINING: 'Remaining'
};
var REWARD_PROFILE = {
  WELCOME: 'WELCOME',
  NA: 'N/A'
};
var NAVIGATION_BAR = {
  BUY: 'BUY',
  DEAL: 'DEAL',
  SALE: 'SALE'
};
var VIP_GAMES = {
  VIP_GAMES_TITLE: 'Play the best games straight from the casino floor!',
  CHOOSE_PASS: 'Choose your pass',
  AGREE_TCS: 'Agree T&Cs',
  GAIN_INSTANT_ACCESS: 'Gain instant access',
  PLAY_50_GAMES: 'Play 50+ games',
  TIME_REMAINING: 'TIME REMAINING'
};
var VIP_ACCESS_FLOW = {
  ALREADY_HAVE_VIP_ACCESS: 'You already have access to the',
  ROOM: 'Room',
  VIP_ACCESS_NEEDED: 'ACCESS NEEDED',
  VIP_ACCESS_WAYS: 'You can access the High Limit Room in the following ways:',
  VIP: 'High Limit',
  REDEEM_ACCESS: 'REDEEM ACCESS',
  PURCHASE_ACCESS: 'PURCHASE ACCESS'
};
var UPGRADE_ACCOUNT_FLOW = {
  ALERT_KYC_SUCCESS: "We've verified that you are 18 or over.",
  ALERT_KYC_ERROR: 'NOT VERIFIED, TRY AGAIN!',
  ALERT_DUP_ERROR: "Looks like you're a Member of The Star Club.",
  SUCCESS_NOTIFICATION_TITLE: 'Success! Your verified account has been created.',
  SUCCESS_NOTIFICATION_MESSAGE: 'From now on, you must log in with your Member ID - ',
  DETAILS_SHOULD_MATCH_DOC: 'The details you enter here should match your official documents. Member of The Star Club? ',
  CLICK_HERE: 'Click here',
  LOG_IN_AND_SKIP: ' to log in and skip',
  REDIRECTING_TO_STAR_CLUB: 'Redirecting to the Star Club Login...'
};
var UPDATE_TERMS = {
  POLICY: 'POLICY',
  TERMS: 'TERMS',
  UPDATE_TERMS_ERROR: 'There is an error, try again later'
};
var START = {
  SIGNUP_TITLE: 'Create Account',
  CANT_FIND_MEMBER_ID: "Can't find your Member ID?",
  CHECK_WELCOME_EMAIL: 'Check your welcome email from StarPlay or any other recent emails from us.',
  CONFIRM_TERMS_AGREE: 'I confirm I am over the age of 18 & I agree to the ',
  MARKETING_CONSENT: ' I consent to receiving marketing & promotional material from ',
  PRIVACY_POLICY_AGREE: ' & agree to the Privacy Policy of ',
  CONTACT_BUTTON: 'CONTACT',
  RETRY_BUTTON: 'RETRY',
  LOG_IN_HERE: 'LOG IN HERE',
  LOG_IN: 'log in',
  PLAY_AS_GUEST: 'PLAY AS GUEST',
  CHOOSE_PASSWORD: 'CHOOSE PASSWORD',
  ALREADY_HAVE_ACCOUNT: 'Already have an account?',
  OR: 'OR',
  HRI: 'Hard Rock Jackpot Casino ',
  SGA: 'Seminole Social Casino ',
  TI: 'Treasure Island Resort & Casino',
  ADMIRAL: 'ADMIRAL Fun',
  FOOTER_TEXT: '',
  WELCOME_START: 'WELCOME!'
};
var SIGNUP = {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  CONFIRM_PASSWORD: 'Confirm password',
  RECEIVE_OFFERS_FROM: "I'd like to receive exclusive news and offers from ",
  HAVE_READ_AND_ACCEPT: 'I have read and accept ',
  AND: 'AND',
  RECEIVE_FURTHER_INFO_FROM_SGA: 'I would like to receive further information from Seminole Gaming and its affiliates on promotions, products and services.',
  RECEIVE_FURTHER_INFO_FROM_TI: 'I would like to receive further information from Treasure Island Gaming and its affiliates on promotions, products and services.',
  RECEIVE_OFFERS_FROM_HRI: "I'd like to receive exclusive news and offers from Hard Rock Jackpot Casino",
  SIGNING_UP: 'SIGNING UP ...',
  RECEIVE_FURTHER_INFO_FROM_ADMIRAL: 'I would like to receive further information from ADMIRAL Fun and its affiliates on promotions, products and services.',
  EMAIL_ALREADY_EXISTS: 'Email already exists.'
};
var FEATURE_COMPLETE = {
  COMPLETE: 'Completed, well done!',
  PICK_REWARD: 'Tap here to pick your reward',
  SPIN_WHEEL: 'Tap here to spin the wheel'
};
var CHEAT_MENU_SCREEN = {
  OPEN_GAME: 'Open game with game id',
  SELECT_MODAL: 'Select Modal',
  OPEN: 'Open',
  GO: 'GO',
  OPEN_BUTTON: 'OPEN',
  SELECT_OPTION: 'Select option...',
  TRIGGER_MOON: 'Trigger moon challenge animation',
  SHOW: 'SHOW'
};
var COMING_SOON = {
  COMING_SOON_TITLE: 'Coming Soon'
};
var CONNECTION_LOST = {
  CONNECTION_LOST_TITLE: 'Connection Lost',
  INTERNET_CONNECTION: 'Please check your internet connection.'
};
var FAVOURITE_HELPER = {
  REMOVE_FAVOURITE_GAME: 'REMOVE FAVOURITE GAMES',
  ARE_YOU_SURE_REMOVE: 'Are you sure you want to remove this game from favourite list?',
  CANCEL_FAVOURITE: 'CANCEL'
};
var PAYMENT_INFO = {
  AGE_RESTRICTION: 'Players must be 18 years of age to purchase.',
  DATE_OF_BIRTH: 'Date of birth',
  COUNTRY: 'Country',
  STATE_PROVINCE: 'State/Province'
};
var SHOP = {
  CONSUMABLE_CLAIM_FAILED_ALERT: 'Consumable Claim Failed',
  ALREADY_CLAIMED_BONUS_OR_EXPIRED: 'You have already claimed this bonus or the promotion has expired.',
  SORRY: 'SORRY',
  EXTRA_PERCENTAGE: '% EXTRA',
  WAS: 'WAS',
  ACCESS: 'Access',
  FREE: 'FREE',
  GET: 'GET',
  MINUTE: 'Minute',
  DAYS: 'Days'
};
var REWARD_CENTER = {
  YOUR: 'Your ',
  EXPIRE_ON: ' expire on ',
  BE_QUICK_AND_REDEEM_NOW: ' so be quick and redeem one of our fantastic offers now!',
  REWARD_CENTER_PROFILE: {
    register_card: {
      title: 'NEED A TREASURE ISLAND UNITY CARD?',
      text: 'Create a Treasure Island Card account online today! A card is required to redeem your Treasure Island Resort & Casino Loyalty Points for real world offers.',
      button: 'REGISTER'
    },
    link_card: {
      title: 'LINK YOUR TREASURE ISLAND UNITY CARD',
      text: 'Link your Treasure Island Card account to Treasure Island Resort & Casino to redeem your Loyalty Points for exciting real world offers!'
    }
  },
  AVAILABLE_BALANCE: 'Available Balance:',
  LOYALTY_POINTS: 'Loyalty Points',
  LINK_ACCOUNT_ONBOARDING_TITLE: 'Do you already have a card?',
  LINK_ACCOUNT_ONBOARDING_SUBTITLE: 'Link your account to receive',
  LINK_OR_REGISTER_BENEFITS_CLICK_HERE: 'Click here ',
  LINK_OR_REGISTER_BENEFITS_CHECK: 'to check the benefits',
  REWARD_CENTER_OFFER_DETAILS_TITLE: 'OFFERS',
  REWARD_CENTER_INITREWARDS_FAILED_MESSAGE: "We're sorry for the inconvenience! There was a error opening the Rewards Center. Please contact support team by using the \"Need Help?\" above.",
  TIER: 'Tier'
};
var RESET_PASSWORD = {
  INVALID_BODY_MESSAGE: 'Your new password must be at least 8 characters and a combination of number and letters',
  SENDING_NEW_PASSWORD_REQUEST: '...Sending the change password request',
  TYPE_NEW_PASSWORD_BELOW: 'Please type your new password below',
  PASSWORD_HAS_BEEN_RESET: 'Your password has been Reset! Please login with your new password!',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  THANKS: 'THANKS'
};
var PURCHASE_SUCCEEDED = {
  PURCHASE_SUCCESSFUL: 'PURCHASE SUCCESSFUL',
  ACCESS_GRANTED: 'Access Granted!',
  ENJOY_EXCLUSIVE_COLLECTION_MESSAGE: 'Enjoy our exclusive collection of hand-picked games!',
  COINS_HAVE_BEEN_ADDED_MESSAGE: 'Your Coins have been added to your balance.'
};
var RATE_US = {
  DO_YOU_LIKE_OUR_GAME: 'DO YOU LIKE OUR GAME ?',
  PLEASE_RATE_US: 'PLEASE RATE US'
};
var PURCHASE_FLOW = {
  ADD: 'ADD',
  CONFIRM_DELETE_CARD: 'Delete card?',
  YES: 'YES',
  APPLY: 'Apply',
  CARD_TYPE: 'Card type',
  CARD_HOLDER_NAME: 'Card Holder Name',
  CREDIT_CARD_NUMBER: 'Credit Card Number',
  EXPIRY_MONTH: 'Expiry Month',
  EXPIRY_YEAR: 'Expiry Year',
  MY: 'MY',
  CVV: 'CVV',
  CVV_NUMBER: 'CVV NUMBER',
  CVV_OUTLINED_IN_GREEN: 'Your CVV security code is outlined in green for the following card types: VISA & Mastercard',
  CARD_NICKNAME: 'Card Nickname',
  PURCHASE: 'PURCHASE',
  COINS: 'COINS',
  BOOST: 'BOOST',
  TRANSACTION_COULD_NOT_BE_PROCESSED: 'Sorry, your transaction could not be processed.',
  CONTACT_CUSTOMER_SUPPORT: 'Contact customer support.',
  TOTAL: 'TOTAL',
  PURCHASE_FLOW_GENERIC_ERROR: 'An Error Occurred',
  PURCHASE_FLOW_CLOSE_ERROR: 'Close',
  YOU_MUST_ENTER_A_PROMO_CODE: 'You must enter a promo code!',
  KYC_LOCKOUT_TITLE: 'Contact us',
  KYC_LOCKOUT_MESSAGE: "Unfortunately, we haven't been able to verify your account using the details provided so far. Please contact our friendly Support Team, they will be happy to help.",
  KYC_LOCKOUT_BUTTON_LABEL: 'CONTACT US',
  PURCHASE_CANCELED: 'Transaction was canceled by the user',
  STORE_CONNECTION_ERROR: 'Connection Error - Please check your internet connection',
  ITEM_SKU_IS_MISSING: 'Selected Itme is missing SKU value',
  RECEIPT_UNAVAILABLE: 'The Purchase receipt is unavailable',
  SELECT_COUNTRY: 'Select Country',
  SELECT_STATE: 'Select State',
  CREDIT_CARD_MONTH: 'MM',
  CREDIT_CARD_YEAR: 'YY'
};
var OUT_OF_COIN = {
  VISIT_STORE: 'VISIT STORE',
  QUICK_BUY: 'QUICK BUY'
};
var TIMER = {
  TIMER_LEFT_DAY: 'd',
  TIMER_LEFT_HOUR: 'h',
  TIMER_LEFT_MINUTE: 'm'
};
var APP_UPDATE = {
  UPDATE_AVAILABLE: 'Update Available',
  UPDATE_REQUIRED: 'Update Required',
  UPDATE_NOW: 'Update Now!',
  UPDATE_TEXT_SHOULD: 'Please update your app to see the latest games and features',
  UPDATE_TEXT_MUST: 'Please update your app to play the latest games and features'
};
var MISSIONS = {
  TIME_REMAINING_PREFIX: 'TIME LEFT: ',
  LOCKED_DESCRIPTION: 'You can only start one mission at a time.\n Finish your current mission to access more!',
  WIN_TEXT: 'WIN',
  TIME_LEFT_TEXT: 'TIME LEFT',
  MYSTERY_REWARD: 'MYSTERY REWARD',
  MISSION_DONE_CLAIM_REWARD_TOOLTIP: 'Your mission is now completed. CLAIM your reward!',
  MISSION_ENDS_SOON_TOOLTIP: 'Your mission ends soon. HURRY to complete it and claim your reward!'
};
var LOGIN = {
  FORGOT_PASSWORD: 'Forgot Password?',
  PASSWORD: 'Password',
  LOGIN: 'LOG IN',
  GENERIC_LOGIN_ERROR_TITLE: 'Unable to log in',
  GENERIC_LOGIN_ERROR_MESSAGE: 'Login failed. Please contact support',
  FACEBOOK_LOGIN_ERROR: 'You must share your email address to log in with Facebook. Please try again.',
  FACEBOOK_ACCEPT_PERMISSION: 'You must accept Facebook email permissions to continue. Try again.',
  GOOGLE_LOGIN_ERROR: 'You must enter your Google credentials to log in with Google. Please try again.',
  GOOGLE_PLAY_SERVICE_ERROR: 'Play Services are not available or outdated.',
  APPLE_LOGIN_ERROR: 'You must enter your Apple credentials to log in with Apple. Please try again.',
  APPLE_LOGIN_UPDATE_ERROR: 'Please update your Operating System to the latest version in order to use Apple Login.',
  LOGIN_EMAIL_REQUIRED: 'Email is required',
  LOGIN_PASSWORD_REQUIRED: 'Password is required'
};
var LINK_LOYALTY_CARD = {
  TRY_LINKING_AGAIN: 'Please try linking your card again',
  UNABLE_TO_LINK_CARD: 'Unable To Link The Star Club Account',
  SESSION_EXPIRED: 'SESSION EXPIRED',
  PROCESSING: 'Processing! Please wait...',
  YOUR_ACCOUNT_IS_NOW_LINKED: 'Your account is now linked!',
  ACCOUNT_LINKED_MESSAGE: 'You must log in with your Member ID and Password from now on',
  CONFIRM_EMAIL: 'CONFIRM EMAIL',
  SIMPLY_ENTER_UNIQUE_EMAIL: 'Simply enter a unique email address to activate your account. This email will become your new contact address for The Star Club',
  AN_UNEXPECTED_ERROR: 'An unexpected error occurred',
  NUMBER: 'Number'
};
var LINK_ACCOUNT_FORM = {
  FORM_INVALID_ERROR: 'The form needs be complete to submit',
  AGE_UNDER_18_OR_FORM_INCOMPLETE_ERROR: 'The age must be over 18 years old and the form needs be complete to submit',
  LINK: 'LINK',
  TERMS_AGREE_MESSAGE: 'By linking your card, you also agree to the',
  TERMS_OF_SERVICE: 'Terms of Service',
  EARN: 'Earn',
  WHEN_YOU_LINK_YOUR_ACCOUNT: 'when you link your account',
  DATE_OF_BIRTH: 'Date of Birth',
  YEAR: 'Year',
  MONTH: 'Month',
  DAY: 'Day',
  PIN: 'PIN',
  LINK_CARD_TITLE: 'Link your ADMIRAL Fun Card',
  LINK_CARD_SUBTITLE: 'Link your ADMIRAL Fun Card and gain access to exclusive Member benefits!',
  LOYALTY_CARD_TITLE: 'ADMIRAL Fun Card',
  PROPERTY_SELECTOR: 'Select Your Property'
};
var LINK_ACCOUNT = {
  LINK_YOUR_ACCOUNT_TODAY_AND_EARN: 'Link your account today and earn',
  FREE_COINS_AND_BENEFITS: 'instantly! Other benefits include: ',
  LINK_ACCOUNT_TITLE: 'Link Account Now',
  LINK_ACCOUNT_BUTTON: 'Link Account!',
  BRONZE: 'BRONZE',
  PLATINUM: 'PLATINUM',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  DIAMOND: 'DIAMOND',
  ACCOUNT_ALREADY_LINKED_TITLE: 'Already linked',
  ACCOUNT_ALREADY_LINKED: 'Your account is already linked to a card. Check out the Reward Center where you can claim amazing rewards!',
  LINK_ACCOUNT_DESCRIPTION: ['Get a special Tier Bonus every day you log in', 'Get 1 Tier Point for every $20 you spend on Coins or other in-app purchases', '*REAL COPY NEEDED*Platinum and Diamond Members get instant aces to the VIP Room, 24/7!'],
  LINK_CARD_SIGNUP: 'No Card?',
  LINK_CARD_SIGNUP_CTA: 'SIGNUP NOW!',
  LINK_CARD_OTP_CONSENTS: 'By linking your account, you agree to the Unity',
  REGISTER_CARD_OTP_CONSENTS: 'By signing up for a reward card, you agree to the Unity',
  UNITY_LINK_ACCOUNT_INFO_TITLE: 'Link your Card Now!',
  UNITY_LINK_ACCOUNT_INFO_SUBTITLE: 'Link your account to gain instant access to exclusive Member benefits'
};
var LEADERBOARDS = {
  NAME_LABEL: 'Name',
  RANK_LABEL: 'Rank',
  POINTS_LABEL: 'Points',
  PRIZE_LABEL: 'Prize',
  REMAINING_TIME: 'Remaining Time: ',
  YOUR_RANK: 'Your Rank:',
  UNRANKED: 'unranked',
  SCORES: 'scores',
  HOURLY_TAB: 'hourly',
  WEEKLY_TAB: 'weekly',
  DAILY_TAB: 'daily',
  GET_LEADERBOARDS_ERROR: 'An error has occured while getting leaderboards'
};
var GUEST_LOGIN = {
  GENERIC_LOGIN_ERROR: 'Something went wrong. Error Code:',
  TRY_AGAIN_LATER: 'please try again later.'
};
var GENERIC_MESSAGE = {
  GENERIC_MESSAGE_ERROR: 'Error'
};
var GAME = {
  GAME_UNAVAILABLE: 'Game unavailable',
  ANOTHER_GAME_DOWNLOADING: 'ANOTHER GAME DOWNLOADING RIGHT NOW...',
  DOWNLOADING_GAME: 'DOWNLOADING NOW...',
  PROGRESS: 'PROGRESS:'
};
var FORGOT_PASSWORD = {
  FORGOT_PASSWORD_TITLE: 'forgot password',
  ENTER_YOUR_REGISTERED_EMAIL: 'Enter your registered email address below and click submit to be sent a password reset email',
  ACCOUNT_HAS_BEEN_LINKED: 'Your account has been linked!',
  INVALID_EMAIL: 'Email is not valid'
};
var FAVOURITES_INFORMATION = {
  LEVEL_UP_TEXT: 'Level Up',
  FAVORITES_REQUIRED_LEVEL: 'Level up to level 3 to unlock this feature'
};
var FAVOURITES_EXPIRED = {
  FAVOURITES_GAMES_EXPIRED: 'Favourites Games Expired',
  GO_TO_VIP: 'Go to VIP'
};
var FAVOURITE_LIST_DIALOGUE = {
  FAVOURITES_ARE_FULL: 'Your Favourites are currently full',
  SELECT_A_GAME_TO_REPLACE: 'Please select a game to replace:'
};
var ACCOUNT = {
  DELETE_ACCOUNT_WARNING: 'Once the account is deleted, your progress will be permanently lost as well as your access to the account. \r\n Are you Sure?',
  EMAIL: 'Email',
  EDIT: 'EDIT',
  CHANGE_PASSWORD: 'Change Password',
  PASSWORD_HINT: "Use a strong password that you don't use elsewhere",
  DELETE_ACCOUNT: 'Delete Account',
  PROMOTIONAL_EMAIL_OPTION: 'Allow Promotional Emails',
  NONE: 'None'
};
var VIP_ITEM = {
  BUY: 'BUY',
  FREE: 'FREE',
  GET: 'GET'
};
var CREDIT_CARD_DETAIL = {
  TOTAL: 'TOTAL'
};
var GEO_CHECK = {
  GEO_CHECK_ERROR_TITLE: 'Oops',
  GEO_CHECK_ERROR_MESSAGE: "We're sorry, this app is currently not available in your country."
};
var ONE_TIME_PASSWORD = {
  ONE_TIME_PASSWORD_TITLE: 'One Time Password',
  ONE_TIME_PASSWORD_SENDING_REQUEST: 'Validating your One Time Password...',
  ONE_TIME_PASSWORD_SENDING_REQUEST_ERROR: 'Request has failed, please try to resend again.',
  ONE_TIME_PASSWORD_MESSAGE: 'Please enter the verification code sent to the email associated with your Unity by Hard Rock account',
  ONE_TIME_PASSWORD_AUTENTICATED: 'You have successfuly authenticated your account.',
  ONE_TIME_PASSWORD_AUTENTICATION_ERROR: 'Request has failed, please try again later',
  ONE_TIME_PASSWORD_BUTTON_SUBMIT: 'SUBMIT',
  ONE_TIME_PASSWORD_BUTTON_RESEND: 'RESEND'
};
var SIGN_UP = {
  REGISTER: 'REGISTER',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_REQUIRED: 'Last name is required'
};
var FORM_VALIDATIONS = {
  INVALID_EMAIL_FORMAT: 'Invalid email format',
  EMAIL_REQUIRED: 'Email is required',
  PASSWORD_LENGTH: 'Your password must be at least 6 characters long.',
  PASSWORD_REQUIRED: 'Password is required',
  VALIDATOR_PASSWORD: 'Your password must contain a number and at least 8 characters.',
  VALIDATOR_NOT_EMPTY: 'Must not be empty.',
  VALIDATOR_LETTERS_ONLY: 'Must only use letters.',
  VALIDATOR_NUMBERS_ONLY: 'Must only use numbers.',
  VALIDATOR_WORDS: 'Must only use letters.',
  VALIDATOR_POSTAL: 'Invalid postal code.',
  VALIDATOR_ADULT_ONLY: 'You must be 18 years old or older.',
  VALIDATOR_CREDIT_CARD: 'Must only use numbers and be at least 13 digits.',
  VALIDATOR_CVV: 'Must only use numbers and be at least 3 digits.'
};
var FTUE = {
  FTUE_TAP_FIRST_SPIN: 'PLAY YOUR FIRST SPIN!',
  FTUE_LEVEL_UP_TO_GET: 'LEVEL UP TO GET',
  FTUE_BETTER_REWARDS: 'BETTER REWARDS',
  FTUE_BETTER_BIGGER_BETS: 'AND BIGGER BETS'
};
var PUSH_NOTIFICATION = {
  PUSH_NOTIFICATION_TIME_BONUS_READY: '🤑 Your Free Coins Are Ready! 💰',
  PUSH_NOTIFICATION_TIME_BONUS_LOGIN: 'Log in and collect your Time Bonus now!',
  PUSH_NOTIFICATION_MISSION_ALMOST: '⏰VICTORY IS CLOSE!⏰',
  PUSH_NOTIFICATION_MISSION_ALMOST_TEXT: 'HURRY to complete your mission. You have 1 hour left!'
};
var PAYMENT_INFO_FORM = {
  PAYMENT_INFO_FIRST_NAME: 'First Name',
  PAYMENT_INFO_LAST_NAME: 'Last Name',
  PAYMENT_INFO_YEAR: 'Year',
  PAYMENT_INFO_MONTH: 'Month',
  PAYMENT_INFO_DAY: 'Day',
  PAYMENT_INFO_ADDRESS_LINE_1: 'Address - Line 1',
  PAYMENT_INFO_ADDRESS_LINE_2: 'Address - Line 2(Optional)',
  PAYMENT_INFO_COUNTRY: 'Country',
  PAYMENT_INFO_CITY: 'City',
  PAYMENT_INFO_STATE: 'State',
  PAYMENT_INFO_ZIP: 'Zip Code',
  PAYMENT_INFO_STATE_PROVINCE: 'State/Province',
  PAYMENT_INFO_SAVE_YOUR_CARD: 'Save this card for future purchases',
  PAYMENT_INFO_SELECT_METHOD: 'Select payment method'
};
var LIMITED_TIME_OFFER = {
  ONLY: 'ONLY',
  CURRENCY_SIGN: '$'
};
var CURRENCY_SELECTOR = {
  BUY_NOW: 'BUY NOW'
};
var NOTIFICATION_MODAL = {
  NOTIFICATION_MODAL_CANCEL: 'Cancel'
};
export var TEXTS = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, BONUS_LINK_MESSAGE), MESSAGES), GEO_CHECK), REGISTER_REWARD_CARD), MODAL_TITLE), TERMS_MODAL), CONGRATS), OFFER_DETAIL), DAILY_SPIN), VIDEO_ADS), WEB_FINISH_PURCHASE), TOOLTIP), TERMS_AND_CONDITIONS), AUTH_SWITCH), AUTO_FORM_INPUT), SMART_BANNER), FORM), GAMETILE), SIDE_MENU), GAME_VIEW), IAP_TERMS), LEVEL_BAR), LEVEL_UP), AUDIO_VIEW), DATE_PICKER), MESSAGE_ITEM), MESSAGE_DETAILS), HISTORY_DETAIL), HISTORY_LIST), REWARD_PROFILE), NAVIGATION_BAR), VIP_GAMES), VIP_ACCESS_FLOW), UPGRADE_ACCOUNT_FLOW), UPDATE_TERMS), START), SIGNUP), FEATURE_COMPLETE), CHEAT_MENU_SCREEN), COMING_SOON), CONNECTION_LOST), FAVOURITE_HELPER), PAYMENT_INFO), SHOP), REWARD_CENTER), RESET_PASSWORD), PURCHASE_SUCCEEDED), RATE_US), PURCHASE_FLOW), OUT_OF_COIN), MISSIONS), LOGIN), LINK_LOYALTY_CARD), LINK_ACCOUNT_FORM), LINK_ACCOUNT), LEADERBOARDS), GUEST_LOGIN), GENERIC_MESSAGE), GAME), EVENTS), FORGOT_PASSWORD), FAVOURITES_INFORMATION), FAVOURITES_EXPIRED), FAVOURITE_LIST_DIALOGUE), ACCOUNT), SETTINGS), WATCH_AND_EARN_INFO), VIP_ITEM), CREDIT_CARD_DETAIL), ONE_TIME_PASSWORD), SIGN_UP), AD_BLOCK), LIMITED_TIME_OFFER), ON_DEMAND_RESOURCES), PUSH_NOTIFICATION), FORM_VALIDATIONS), PAYMENT_INFO_FORM), CURRENCY_SELECTOR), TIMER), APP_UPDATE), FTUE), NOTIFICATION_MODAL);